import { Injectable } from '@angular/core';
import { IndicatorDuration, IndicatorType } from '../agent-stat-enums';
import { agentStatConfig, TriggerTypes } from '../agent-stat.config';
import { TriggerService } from './trigger.service';
import { StatSourceService } from './stat-source.service';
import { AgentStatObject } from '../agent-stat-object';
import { AgentStatIndicator } from '../models/agent-stat.model';

@Injectable()
export class StatService {

  constructor(private _triggersService: TriggerService,
              private _statSourceService: StatSourceService) {
  }

  public initStat(indicator: AgentStatIndicator) {
    const statObj = new AgentStatObject(this._statSourceService, this._triggersService);
    switch (indicator.indicatorType) {
      case IndicatorType.NUMBER_OF_CLOSED_CHATS:
      case IndicatorType.CONVERSION_COUNT:
      case IndicatorType.CONVERSION_AMOUNT:
      case IndicatorType.SURVEY_NPS:
      case IndicatorType.SURVEY_KNOWLEDGE:
      case IndicatorType.SURVEY_PROFESSIONALISM:
      case IndicatorType.SURVEY_JUST_OVERALL:
      case IndicatorType.SURVEY_RESPONSIVENESS:
        const statConfig = agentStatConfig[IndicatorType[indicator.indicatorType]];
        statObj.setSource(statConfig.source, indicator)
          .then(() => {
            this.addTriggersFromConfig(statObj, statConfig.triggers);
            this.addDynamicTriggers(statObj, indicator);
          });
        return statObj;
      default:
        break;
    }
  }

  private addTriggersFromConfig(statObj: AgentStatObject, triggers: TriggerTypes[]) {
    statObj.addTriggers(triggers);
  }

  private addDynamicTriggers(statObj: AgentStatObject, indicator: AgentStatIndicator) {
    if (indicator.indicatorDuration === IndicatorDuration.TODAY) {
      statObj.addTriggers([TriggerTypes.DAILY_REFRESH]);
    } else if (indicator.indicatorDuration === IndicatorDuration.THIS_WEEK) {
      statObj.addTriggers([TriggerTypes.WEEKLY_REFRESH]);
    }
  }
}
